<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1 class="mat-headline-4 !mb-0">Products</h1>
    <pt-buttons-container>
      <button mat-flat-button color="primary" (click)="add()">
        Create Product
      </button>
    </pt-buttons-container>
  </div>

  <pr-content-container>
    <ng-container *ngIf="products$ | async as products">
      <mat-list *ngIf="products.length; else noProducts">
        <pr-product-list-item
          *ngFor="let product of products; trackBy: trackByProduct"
          [product]="product"
        />
      </mat-list>
      <ng-template #noProducts>
        <pr-empty-state image="list" title="products" />
      </ng-template>
    </ng-container>
  </pr-content-container>
</div>
